function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "19",
  viewBox: "0 0 17 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.633 14.933A.933.933 0 007.566 14V8.4a.933.933 0 00-1.866 0V14a.933.933 0 00.933.933zm9.333-11.2h-3.733V2.8a2.8 2.8 0 00-2.8-2.8H7.566a2.8 2.8 0 00-2.8 2.8v.933H1.033a.933.933 0 000 1.867h.933v10.267a2.8 2.8 0 002.8 2.8h7.467a2.8 2.8 0 002.8-2.8V5.6h.933a.933.933 0 000-1.867zM6.633 2.8a.933.933 0 01.933-.933h1.867a.933.933 0 01.933.933v.933H6.633V2.8zm6.533 13.067a.933.933 0 01-.933.933H4.766a.934.934 0 01-.933-.933V5.6h9.333v10.267zm-2.8-.934A.933.933 0 0011.3 14V8.4a.934.934 0 00-1.867 0V14a.934.934 0 00.933.933z",
  fill: "#F6335D"
})));